import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import ConfirmModal from "components/common/ConfirmModal";
import {
  MdMoreVert,
  MdOutlineRemoveRedEye,
  MdOutlineEdit,
  MdDelete,
} from "react-icons/md";
import Toast from "components/Toast";
export default function ProgramTable({
  data,
  onDelete,
  onRefresh,
  selectedRows = [],
  onSelectRow,
  onSelectAll,
  viewButton,
  fetchData
}) {
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [openUpward, setOpenUpward] = useState(false);
  const dropdownRef = useRef(null);
  const [toast, setToast] = useState({
    open: false,
    title: "",
    message: "",
    type: "success",
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggleMenu = (e, rowId) => {
    e.stopPropagation();
    if (openDropdownId === rowId) {
      setOpenDropdownId(null);
    } else {
      const buttonRect = e.currentTarget.getBoundingClientRect();
      const spaceBelow = window.innerHeight - buttonRect.bottom;
      setOpenUpward(spaceBelow < 150);
      setOpenDropdownId(rowId);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await onDelete(deleteId);
      setToast({
        open: true,
        title: "Success",
        message: "Program deleted successfully",
        type: "success",
      });
      setDeleteId(null);
      fetchData();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="table-scroll-body">
        <table className="custom-table">
          <thead className="custom-table-header text-gray-800">
            <tr>
              <th className="w-12 text-center">
                <input
                  type="checkbox"
                  className="table-checkbox"
                  onChange={onSelectAll}
                  checked={
                    data.length > 0 && selectedRows.length === data.length
                  }
                />
              </th>
              <th>Title</th>
              <th>Type</th>
              <th>Date & Start Time</th>
              <th>Details</th>
              <th className="w-16 text-center"></th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan="6"
                  className="custom-table-cell py-12 text-center text-gray-500"
                >
                  No programs found
                </td>
              </tr>
            ) : (
              data.map((item, index) => {
                const rowId = item._id || index;
                const isChecked = selectedRows.includes(rowId);
                const isMenuOpen = openDropdownId === rowId;

                const formattedDate = item.programDate
                  ? new Date(item.programDate.split("T")[0] + "T00:00:00").toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })
                  : "N/A";
               

                const isMeeting =
                  item.programType?.toLowerCase().trim() === "meeting";

                return (
                  <tr key={rowId} className="custom-table-row">
                    <td className="custom-table-cell text-center">
                      <input
                        type="checkbox"
                        className="table-checkbox"
                        checked={isChecked}
                        onChange={() => onSelectRow(rowId)}
                      />
                    </td>

                    <td className="custom-table-cell ">
                      {item.title || "N/A"}
                    </td>

                    <td className="custom-table-cell">
                    
                        {item.programType || "N/A"}
                      
                    </td>

                    <td className="custom-table-cell ">
                      <div className="flex flex-col">
                        <span className="font-medium">{formattedDate}</span>
                        <span className="text-xs text-gray-500">
                          {item.startTime || "N/A"}
                        </span>
                      </div>
                    </td>

                    <td className="custom-table-cell  max-w-xs truncate">
                      {isMeeting ? (
                        <div className="flex flex-col gap-1">
                          <span className="truncate" title={item.description}>
                            {item.description || "No description"}
                          </span>
                          {item.speakers && item.speakers.length > 0 && (
                            <span className="text-xs text-blue-600 font-medium">
                              Speakers: {item.speakers.map((s) => s.name).join(", ")}
                            </span>
                          )}
                        </div>
                      ) : (
                        <span className="text-gray-400 italic">Standard Program</span>
                      )}
                    </td>

                    <td className="custom-table-cell relative text-center">
                      <button
                        onClick={(e) => handleToggleMenu(e, rowId)}
                        className="action-menu-btn"
                      >
                        <MdMoreVert className="text-lg text-gray-800" />
                      </button>

                      {isMenuOpen && (
                        <div
                          ref={dropdownRef}
                          className={`action-dropdown-menu ${
                            openUpward ? "menu-bottom" : "menu-top"
                          }`}
                        >
                          <button
                            onClick={() => {
                              setOpenDropdownId(null);
                              viewButton(item);
                            }}
                            className="action-dropdown-item"
                          >
                            <MdOutlineRemoveRedEye className="text-base" />
                            View
                          </button>

                          <div className="action-dropdown-divider" />

                          <Link
                            to={`/admin/program/edit/${item._id}`}
                            onClick={() => setOpenDropdownId(null)}
                            className="action-dropdown-item"
                          >
                            <MdOutlineEdit className="text-base" />
                            Edit
                          </Link>

                          <div className="action-dropdown-divider" />

                          <button
                            onClick={() => {
                              setOpenDropdownId(null);
                              setDeleteId(item._id);
                            }}
                            className="action-dropdown-item item-danger"
                          >
                            <MdDelete className="text-base" />
                            Delete
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      <ConfirmModal
        open={Boolean(deleteId)}
        title="Are you sure?"
        message="You are about to delete this program. This action cannot be undone."
        confirmText="Yes, Delete"
        loading={loading}
        onConfirm={handleDelete}
        onCancel={() => setDeleteId(null)}
      />
      <Toast
        open={toast.open}
        title={toast.title}
        message={toast.message}
        type={toast.type}
        duration={1500}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
      />
    </>
  );
}